/* eslint-disable no-unused-vars */
import React, { useMemo, useContext } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import useManagerContext from '../context/useManagerContext';
import './style.css';

export default function Footer() {
  const { workingReport } = useContext(useManagerContext);
  return (
    <Box sx={{ pl: 3, pr: 3 }}>
      <Grid container xs={12} sm={12} md={12}>
        <Grid container xs={5} sm={5} md={5}>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', textAlign: 'left', paddingTop: '20px' }}>
                  Total Made Calls (MTD)
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', paddingTop: '20px' }}>
                  {workingReport?.call ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', paddingTop: '20px' }}>
                  {`${parseFloat(workingReport?.call_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', textAlign: 'left' }}>Planned</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>{workingReport?.plan ?? 0}</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.plan_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', textAlign: 'left' }}>
                  Deviations
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.deviation ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.deviation_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', textAlign: 'left' }}>Total Working Days</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.working_days ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} />

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', textAlign: 'left' }}>MTD Field Days</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.field_days ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} />

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold', textAlign: 'left' }}>Target</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold' }}>#</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold' }}>Call Rate</th>
              </tr>
            </table>
          </Grid>

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', textAlign: 'left' }}>
                  Full Month
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.target ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.target_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal', textAlign: 'left' }}>
                  MTD (Date Range)
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.mtd_date_range ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={4} sm={4} md={4} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.mtd_date_range_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }} />
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold' }}>Total # of MDs</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold' }}>Actual</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold' }}>%</th>
              </tr>
            </table>
          </Grid>

          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold', textAlign: 'left' }}>Reach</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.total_md ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>{workingReport?.reach ?? 0}</th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff', paddingTop: '20px' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.reach_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>

          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'bold', textAlign: 'left' }}>
                  Concentration
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.total_md ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {workingReport?.concentration ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
          <Grid xs={3} sm={3} md={3} sx={{ backgroundColor: '#fff' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <th style={{ width: '100%', fontWeight: 'normal' }}>
                  {`${parseFloat(workingReport?.concentration_percentage).toFixed(2)}%` ?? 0}
                </th>
              </tr>
            </table>
          </Grid>
        </Grid>
        <Grid container xs={1} sm={1} md={1} />
        <Grid
          container
          xs={6}
          sm={6}
          md={6}
          sx={{ backgroundColor: '#fff', pt: 1, pl: 1, pb: 2, height: '100%' }}
        >
          <Grid xs={12} sm={12} md={12}>
            <span style={{ fontWeight: 'bold' }}>Legends:</span>
            <Grid container sx={{ pt: 3 }}>
              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-gray'
                  />{' '}
                  Plotted/Lapsed
                </span>
              </Grid>
              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-dark-gray'
                  />{' '}
                  Plotted/Upcoming
                </span>
              </Grid>

              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-green'
                  />{' '}
                  As Planned
                </span>
              </Grid>

              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-blue'
                  />{' '}
                  Advanced
                </span>
              </Grid>
              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-pink'
                  />{' '}
                  Weekend
                </span>
              </Grid>
              <Grid xs={2} sm={2} md={2}>
                <span style={{ padding: '10px' }}>
                  <div
                    style={{ padding: '10px', display: 'inline-block' }}
                    className='legend-yellow'
                  />{' '}
                  Retrieved
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
